export const instanceLocator = "v1:us1:70765878-2ac8-4e66-938d-b18c7503aded";

export const tokenProvider = "https://chatback123.herokuapp.com/auth";
